export const DEFAULT_PAGE_SIZE = 25;
export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50];
